module.exports = __webpack_public_path__ + "static/media/pricol.ed7d980b.svg";